import { StatusCodes } from "http-status-codes";
import { ALL_SCHEMES_APIS, DOCUMENTS, PATIENT_APIS } from "../utils/constants";
import {
  IScheme,
  ISchemeForm,
  ISchemeOnBoard,
  ISchemeResponse,
} from "../interfaces/IScheme";
import { errorMessage, successMessage } from "../utils/notificationUtils";
import Axios from "../utils/axiosInterceptor"; // Adjust the import path as necessary
import { schemeOnboardingPayload } from "../interfaces/ISchemeOnboarding";

export const fetchAllSchemes = async (): Promise<ISchemeResponse> => {
  try {
    const response = await Axios.get<Array<IScheme>>(
      `${ALL_SCHEMES_APIS.ALL_SCHEMES}`
    );
    if (response.status === StatusCodes.OK) {
      return { schemes: response.data };
    } else {
      return {
        errorMessage: "Cannot fetch all schemes",
        status: response.status,
      };
    }
  } catch (error) {
    throw new Error("Cannot fetch all schemes");
  }
};

export const postPatientScheme = async (
  formData: ISchemeForm,
  patientId: number | undefined,
  schemeId: number | undefined
) => {
  try {
    const response = await Axios.post(
      `${PATIENT_APIS.PATIENT_SCHEMES}/${patientId}/schemeMetaDataId/${schemeId}/patient_schemes`,
      formData
    );
    if (response.status === StatusCodes.CREATED) {
      successMessage("SCHEME ADDED SUCCESSFULLY!");
      return response.data;
    } else if (response.status === 208) {
      errorMessage(response?.data);
    } else {
      return {
        errorMessage: "SCHEME CAN NOT ADDED ",
        status: response.status,
      };
    }
  } catch (error) {
    throw new Error("SCHEME CAN NOT ADDED ");
  }
};

export const updatePatientScheme = async (
  formData: ISchemeForm,
  patientId: number | undefined,
  schemeId: number | undefined | null,
  id: number | undefined
) => {
  try {
    const response = await Axios.patch(
      `${PATIENT_APIS.PATIENT_SCHEMES}/${patientId}/schemeMetaDataId/${schemeId}/patient_scheme/${id}`,
      formData
    );
    if (response.status === StatusCodes.OK) {
      return response.data;
    } else {
      return {
        errorMessage: "Cannot updated patient scheme",
        status: response.status,
      };
    }
  } catch (error) {
    throw new Error("Cannot update patient scheme");
  }
};

// export const fetchAllSchemesOnBoarding = async (
//   accessToken: string,

// ): Promise<any> => {
//   try {
//     const response = await Axios.get<Array<ISchemeOnBoard>>(
//       `${ALL_SCHEMES_APIS.GET_SCHEME_ONBOARD}`
//     );
//     if (response.status === StatusCodes.OK) {
//       return response.data;
//     } else {
//       return {
//         errorMessage: "Cannot fetch all schemes onboarding",
//         status: response.status,
//       };
//     }
//   } catch (error) {
//     throw new Error("Cannot fetch all schemes");
//   }
// };

export const postSchemeOnboarding = async (
  // accessToken: string,
  data: schemeOnboardingPayload
): Promise<any> => {
  try {
    const response = await Axios.post<Array<ISchemeOnBoard>>(
      `${ALL_SCHEMES_APIS.GET_SCHEME_ONBOARD_NEW}`,
      data
    );
    if (response.status === 200) {
      successMessage("SCHEME ONBOARDED SUCCESSFULLY!");
      return response.data;
    } else {
      return {
        errorMessage: "Cannot onboard schemes",
        status: response.status,
      };
    }
  } catch (error) {
    throw new Error("Cannot onboard schemes");
  }
};

export const fetchAllSchemesOnBoarding = async (
  accessToken: string,
  healthCareId: number
): Promise<any> => {
  try {
    const response = await Axios.get<Array<ISchemeOnBoard>>(
      `${ALL_SCHEMES_APIS.GET_SCHEME_ONBOARD}/${healthCareId}/health_care_schemes/getActiveSchemes`
    );
    if (response.status === StatusCodes.OK) {
      return response.data;
    } else {
      return {
        errorMessage: "Cannot fetch all schemes onboarding",
        status: response.status,
      };
    }
  } catch (error) {
    throw new Error("Cannot fetch all schemes");
  }
};

export const fetchSchemesOnBoardingById = async (
  schemeId: number
): Promise<any> => {
  try {
    const response = await Axios.get<Array<ISchemeOnBoard>>(
      `${ALL_SCHEMES_APIS.ALL_SCHEMES}/${schemeId}/scheme_onboarding`
    );
    if (response.status === StatusCodes.OK) {
      return { schemeRes: response.data, status: response.status };
    } else {
      return {
        errorMessage: "Cannot fetch all schemes onboarding",
        status: response.status,
      };
    }
  } catch (error) {
    throw new Error("Cannot fetch all schemes");
  }
};

export const getDocuments = async (
  portalMetaDataId: number,
  schemeMetaDataId: number
) => {
  try {
    const res = await Axios.get(
      `${DOCUMENTS.GET_DOCUMENTS}/${portalMetaDataId}/schemeMetaDataId/${schemeMetaDataId}`
    );
    return res.data;
  } catch (err: any) {
    console.error("Failed to Get documents:", err);
    errorMessage(err?.response?.data || "Please, Try again after sometime");
    throw new Error("Failed to get documents");
  }
};

export const getProcedureList = async (
  caseId: number,
  visitId: number
): Promise<any> => {
  try {
    const response = await Axios.get(
      `${PATIENT_APIS.GET_PORTAL_DATA}/${caseId}/visitInfo/${visitId}/getAllCasePreAuthByCaseIdAndVisitId`
    );
    if (response.status === StatusCodes.OK) {
      return { procedureListRes: response.data, status: response.status };
    } else {
      return {
        errorMessage: response?.data,
        status: response.status,
      };
    }
  } catch (error: any) {
    console.error("Cannot post claim details:", error?.response?.data);
    throw new Error(error?.response?.data || "Cannot post claim details");
  }
};

export const getProcedures = async (
  caseId: number | null,
  hospitalId: number,
  isCghs: boolean,
  procedureType: string,
  schemeId: number
): Promise<any> => {
  try {
    const response = await Axios.post(`${PATIENT_APIS.ALL_PROCEDURES}`, {
      caseId,
      hospitalId,
      isCghs,
      procedureType,
      schemeId,
    });
    if (response.status === StatusCodes.OK) {
      return { procedures: response.data, status: response.status };
    } else {
      return {
        errorMessage: response?.data,
        status: response.status,
      };
    }
  } catch (error: any) {
    console.error("Cannot post claim details:", error?.response?.data);
    throw new Error(error?.response?.data || "Cannot post claim details");
  }
};

export const getProceduresNew = async (
  caseId: number | null,
  hospitalId: number,
  isCghs: boolean,
  procedureType: string,
  schemeId: number
): Promise<any> => {
  try {
    const response = await Axios.post(`${PATIENT_APIS.ALL_PROCEDURES_NEW}`, {
      caseId,
      hospitalId,
      isCghs,
      procedureType,
      schemeId,
    });
    if (response.status === StatusCodes.OK) {
      return { procedures: response.data, status: response.status };
    } else {
      return {
        errorMessage: response?.data,
        status: response.status,
      };
    }
  } catch (error: any) {
    console.error("Cannot post claim details:", error?.response?.data);
    throw new Error(error?.response?.data || "Cannot post claim details");
  }
};

export const getEchsProcedures = async (
  hospitalId: number,
  patientType: string,
  schemeId: number
): Promise<any> => {
  try {
    const response = await Axios.post(`${PATIENT_APIS.ALL_ECHS_PROCEDURES}`, {
      hospitalId,
      patientType,
      schemeId,
    });
    if (response.status === StatusCodes.OK) {
      return { procedures: response.data, status: response.status };
    } else {
      return {
        errorMessage: response?.data,
        status: response.status,
      };
    }
  } catch (error: any) {
    console.error("Cannot get echs procedure details:", error?.response?.data);
    throw new Error(error?.response?.data || "Cannot get echs procedure details");
  }
};
